// Perguntas que as pessoas realmente digitam no Google, com a resposta do Teia.
// Fonte única: o servidor usa isto nos dados estruturados e a página de guia
// mostra o mesmo texto. Divergir seria pedir penalidade de conteúdo oculto.

export type FaqItem = { q: string; a: string };

export const FAQ: FaqItem[] = [
  {
    q: "Como consultar um CNPJ de graça?",
    a: "Digite o CNPJ, a razão social ou o nome do sócio na busca do Teia. A consulta é gratuita, não pede cadastro "
      + "e devolve situação cadastral, endereço, CNAEs, capital social e quadro societário a partir dos dados abertos "
      + "da Receita Federal.",
  },
  {
    q: "Como descobrir os sócios de uma empresa?",
    a: "Abra a ficha do CNPJ: o quadro societário lista nome, qualificação, data de entrada e o miolo público do CPF "
      + "de cada sócio. Clicando em um sócio você vê as outras empresas dele.",
  },
  {
    q: "Dá para ver todas as empresas de uma pessoa pelo nome?",
    a: "Sim. Busque pelo nome completo e o Teia agrupa as empresas em que essa pessoa aparece no quadro societário. "
      + "Como os dados abertos publicam só parte do CPF, confira homônimos pelo conjunto de empresas e cidades.",
  },
  {
    q: "O que é rede societária?",
    a: "É o grafo que liga uma empresa aos seus sócios, esses sócios às outras empresas deles, e assim por diante. "
      + "No Teia ela se chama teia e pode ser expandida camada por camada.",
  },
  {
    q: "Por que esta empresa não tem sócios publicados?",
    a: "Nem todo CNPJ tem quadro societário. MEI e empresário individual são a própria pessoa do titular; filial não "
      + "tem QSA próprio, ele fica na matriz; órgãos públicos e associações têm direção registrada fora dos dados "
      + "abertos. A ficha do Teia diz qual é o caso.",
  },
  {
    q: "De onde vêm os dados?",
    a: "Dos dados abertos do Cadastro Nacional da Pessoa Jurídica, publicados pela Receita Federal e distribuídos por "
      + "espelhos gratuitos como OpenCNPJ, BrasilAPI, Minha Receita e CNPJ.ws. O Teia cruza essas fontes e mostra qual "
      + "respondeu.",
  },
  {
    q: "Com que frequência os dados são atualizados?",
    a: "A Receita Federal publica a base do CNPJ mensalmente, e os espelhos consultados pelo Teia atualizam os dados "
      + "diariamente conforme recebem. Uma alteração recente pode levar alguns dias para aparecer.",
  },
  {
    q: "O Teia é pago?",
    a: "A consulta é grátis e não pede cadastro: busca, ficha, perfil de pessoa, rede societária e o servidor MCP. "
      + "Os planos Pro e Empresa acrescentam o acompanhamento diário de empresas, a consulta em lote com planilha e "
      + "uma chave de API com ritmo maior.",
  },
  {
    q: "Posso usar o Teia dentro do ChatGPT ou do Claude?",
    a: "Sim. O Teia publica um servidor MCP gratuito; basta apontar o cliente de IA para ele e perguntar em linguagem "
      + "natural sobre qualquer CNPJ.",
  },
];
